import mediatekApi from '../apis/mediatek'
import { BASE_WISH_YEAR, WISH_TYPE } from '@/tools/constant'
import { session, KEY_MEDIATEK_2025GIVINGTREE_TOKEN, KEY_MEDIATEK_2025GIVINGTREE_USER_INFO } from '@/tools/storage'

const state = {
  auth: {
    token: '',
    user: {}
  },
  wishAdoptedCount: 0,
  wishUnAdoptedCount: 0,
  wishList: {
    type: WISH_TYPE.WISH,
    currentPage: 0,
    lastPage: 1,
    total: 0,
    loading: false,
    data: []
  },
  wishItem: {},
  myDonates: {
    currentPage: 0,
    lastPage: 1,
    total: 0,
    loading: false,
    data: []
  },
  wishPreTime: '',
  wishStartTime: '',
  wishEndTime: '',
  filter: {
    year: '',
    school: '',
    status: '',
    organizerId: '',
    wishNo: '',
    keyword: '',
    isMine: ''
  },
  schoolList: {
    data: [],
    year: '',
    organizerId: ''
  }
}

const actions = {
  login ({ commit }, { account, password }) {
    return mediatekApi.login(account, password)
      .then(data => {
        if (data.code === 0 && data.data && data.data.token) {
          session.save(KEY_MEDIATEK_2025GIVINGTREE_TOKEN, data.data.token)
          session.save(KEY_MEDIATEK_2025GIVINGTREE_USER_INFO, data.data.user)
          commit('setToken', data.data.token)
          commit('setUserInfo', data.data.user)
        } else {
          throw new Error(data.message)
        }

        return data
      })
  },
  logout ({ commit }) {
    return mediatekApi.logout()
      .then(data => {
        session.remove(KEY_MEDIATEK_2025GIVINGTREE_TOKEN)
        session.remove(KEY_MEDIATEK_2025GIVINGTREE_USER_INFO)
        commit('setToken', '')
        commit('setUserInfo', {})
        return data
      })
  },
  getWishList ({commit, state}, {page, status, batch, schoolName, type, organizerId, wishNo, keyword, isMine}) {
    commit('setWishListLoading', { loading: true, type })
    return mediatekApi.getWishList({ page, status, batch, schoolName, type, organizerId, wishNo, keyword, isMine })
      .then(data => {
        commit('setWishList', { data, type, organizerId })
        return data
      })
      .catch(err => {
        commit('setWishListLoading', { loading: false, type })
        throw err
      })
  },
  getWishItem ({ commit, state }, { id }) {
    return mediatekApi.getWishItem(id)
      .then(data => {
        commit('setWishItem', { data })
        return data
      })
      .catch(err => {
        throw err
      })
  },
  donate ({ commit, state }, {id, data}) {
    return mediatekApi.donate(
      id,
      data
    ).then((data) => {
      commit('setDonateStatus', { id })
      return data
    }).catch(err => {
      throw err
    })
  },
  getMyDonates ({ commit, state }, { page, status, batch, schoolName, type, organizerId, wishNo, keyword }) {
    return mediatekApi.getMyDonates({ page, status, batch, schoolName, type, organizerId, wishNo, keyword })
      .then(data => {
        commit('setMyDonates', { data })
        return data
      })
      .catch(err => {
        throw err
      })
  },
  getWishCount ({ commit }, { batch, schoolName, organizerId }) {
    return mediatekApi.getWishCount({ batch, schoolName, organizerId })
      .then(data => {
        commit('setWishCount', data)
      })
      .catch(err => {
        console.log(err)
      })
  },
  getWishTimes ({ commit }) {
    let batch = new Date().getFullYear() - BASE_WISH_YEAR
    return mediatekApi.getWishTimes(batch)
      .then(data => {
        commit('setWishTimes', data)
      })
      .catch(err => {
        console.log(err)
      })
  },
  getSchools ({ commit }, { year, organizerId }) {
    let batch = ''
    if (year) {
      batch = year - BASE_WISH_YEAR
    }
    return mediatekApi.getSchools({ batch, organizerId })
      .then(res => {
        commit('setSchoolList', { data: res.data, year, organizerId })
        return res.data
      })
  }
}

const mutations = {
  setToken (state, token) {
    state.auth.token = token
  },

  setUserInfo (state, user) {
    state.auth.user = user
  },
  setWishList (state, { data, organizerId }) {
    state.wishList = {
      ...state.wishList,
      organizerId,
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total,
      loading: false,
      data: data.current_page === 1 ? data.data : [
        ...state.wishList.data,
        ...data.data
      ]
    }
  },
  setDonateStatus (state, { id }) {
    const wish = state.wishList.data.find(item => item.id === id)
    if (wish) {
      wish.status = 'end'

      state.wishAdoptedCount++
      state.wishUnAdoptedCount = state.wishUnAdoptedCount - 1 > 0 ? state.wishUnAdoptedCount - 1 : 0
    }
  },
  setWishItem (state, { data }) {
    state.wishItem = data
  },
  clearWishList (state) {
    state.wishList = {
      ...state.wishList,
      currentPage: 0,
      lastPage: 1,
      total: 0,
      loading: false,
      data: []
    }
  },
  setMyDonates (state, { data }) {
    state.myDonates = {
      data: data.current_page === 1 ? data.data : [
        ...state.myDonates.data,
        ...data.data
      ],
      currentPage: data.current_page + 1,
      lastPage: data.last_page,
      total: data.total,
      loading: false
    }
  },
  setWishCount (state, data) {
    state.wishAdoptedCount = data.adopted_count
    state.wishUnAdoptedCount = data.unadopted_count
  },
  setWishTimes (state, data) {
    state.wishPreTime = data && data.pre_time && data.pre_time.replace(/-/g, '/')
    state.wishStartTime = data && data.start_time && data.start_time.replace(/-/g, '/')
    state.wishEndTime = data && data.end_time && data.end_time.replace(/-/g, '/')
  },
  setWishTracing (state, data) {
    state.wishItem = {
      ...state.wishItem,
      is_tracing: data.is_tracing
    }
  },
  setWishFilter (state, filter) {
    state.filter = {
      ...state.filter,
      ...filter
    }
  },
  setWishListLoading (state, { loading }) {
    state.wishList = {
      ...state.wishList,
      loading
    }
  },
  setSchoolList (state, { data, year, organizerId }) {
    state.schoolList = {
      data,
      year,
      organizerId
    }
  }
}

const getters = {
  schoolMap (state) {
    const map = {}
    ;(state.schoolList.data || []).forEach(school => {
      if (school.name) {
        map[school.name] = school.title || school.name
      }
    })
    return map
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
